import React, { useEffect, useState } from 'react';
import ShortTests from '../shorts/Tests';
import ShortNews from '../shorts/News';
import { Helmet } from 'react-helmet-async';
import AdSlot from '../ads/AdSlot';

const TermsOfUse = () => {
    const pageTitle = 'Nutzungsbedingungen | NGCTV';
    const pageDescription =
        'Nutzungsbedingungen von NGCTV – Regeln zur Nutzung, Pflichten der Nutzer, Urheberrechte und Haftungsbeschränkungen.';

    return (
        <>
            {/* SEO / Head */}
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href={`https://ngctv.de/nutzungsbestimmungen`} />
            </Helmet>
            <main>
                <div className='wrapper'>
                    <div className='rows'>
                        <div className='row'>
                            <div className='category'>Nutzungsbedingungen</div>
                            <div class="nutzungsbedingung">
                                <h3> 1.) Geltungsbereich </h3>

                                (1) Die nachfolgenden Bedingungen gelten für die Nutzung von <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span>. <br />
                                Für die Nutzung des Forums lese bitte den Beitrag Regeln! im Forum durch. <br />
                                Die Registrierung und Benutzung von <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> ist kostenlos.<br /><br />
                                (2) Mit der Registrierung bist du mit den Nutzungsbedingungen von <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> einverstanden. <br />
                                Durch deine Einverständnis garantierst du uns, dass du keine Beiträge erstellen wirst, die <br />
                                gegen die Nutzungsbedingung verstoßen.<br /><br />
                                (3) Durch das Benutzen von <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> kommt kein Vertrag zwischen den Nutzern/Nutzerinnen <br />
                                und <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> zustande.<br /><br />

                                <h3> 2.) Pflichten als Nutzer/Nutzerinnen </h3>

                                (1) Einer deiner Pflichten als Nutzer/Nutzerin ist es, dass du keine Beiträge veröffentlichst, <br />
                                die gegen diese Forenregeln, gegen die guten Sitten oder sonst gegen geltendes deutsches <br />
                                Recht verstoßen.<br />
                                <br />

                                Folgende Punkte sind dir nicht gestattet:<br />

                                <ul>
                                    <li>Inhalte zu veröffentlichen, die unwahr sind und deren Veröffentlichung einen Straftatbestand oder eine Ordnungswidrigkeit erfüllt,</li>
                                    <li>Versendung von Spam über <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> an andere Nutzer/Nutzerin,</li>
                                    <li>Verwendung von gesetzlich durch Urheber- und Markenrecht geschützte Inhalte ohne rechtmäßige Berechtigung (z.B. Pressemitteilungen etc.),</li>
                                    <li>Handlungen, die wettbewerbswidrig sind,</li>
                                    <li>mehrfache Einstellung von Themen ins Forum,</li>
                                    <li>eigene Werbung, folglich Schleichwerbung, zu betreiben und</li>
                                    <li>Inhalte zu veröffentlichen, die beleidigend, rassistisch, diskriminierend oder pornographische Elemente aufweisen gegenüber anderen Nutzern/Nutzerinnen und der Allgemeinheit.
                                    </li></ul>
                                Deine Pflicht als Nutzer/ Nutzerin ist es, auf 2 Abs. 1 Nr. 1-7 dieser Nutzungsbedingung, <br />
                                vor  der Nutzung von <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> zu beachten und zu überprüfen, ob du dich an diese Punkte <br />
                                halten möchtest.<br />
                                <br />

                                (2)   Solltest du gegen  2 Abs. 1 Nr. 1-7 dieser Nutzungsbedingung verstoßen, behalten wir <br />
                                uns das Recht vor, gegen dich folgende Schritte vorzunehmen:<br />
                                <br />
                                <ol>
                                    <li>Deine eingestellten Beiträge zu löschen und diese abzuändern,</li>

                                    <li>Verbot weiterhin im Forum Beiträge zu verfassen und</li>

                                    <li>Sperrung des Zugangs als Nutzer/Nutzerin.</li>
                                </ol>
                                (3)  Hast du als Nutzer/Nutzerin nicht die Nutzungsbedingungen beachtet und sind hierdurch <br />
                                mögliche Rechtsverstöße entstanden, die durch deinen eingestellten Inhalte auf <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span>  <br />
                                entstanden sind (Pflichtverletzung), verpflichtest du dich als Nutzer/Nutzerin, uns von <br />
                                jeglichen Ansprüchen, auch den Schadenersatzansprüchen, freizustellen und diesen die <br />
                                Kosten zu ersetzen.<br />
                                <br />

                                Zudem ist der Nutzer/die Nutzerin verpflichtet uns, bei Schadenersatzansprüchen <br />
                                hinsichtlich der Abwehr des durch sein entstandenen Rechtsverstoßes (Pflichtverletzung <br />
                                s.o.), zu unterstützen und die Kosten einer angemessenen Rechtsverteidigung für uns zu <br />
                                tragen.<br />
                                <br />

                                (4)   Durch deine Einverständnis garantierst du uns, dass du keine Beträge erstellen wirst, <br />
                                die gegen die Nutzungsbedingung verstoßen. Entsprechendes gilt auch für das Setzen von <br />
                                externen Links und die Signaturen.<br />
                                <br />

                                <h3> 3.) Übertragung von Nutzungsrechten </h3>

                                Du, als Nutzer/Nutzerin  hast die alleinige Verantwortung des Urheberrechts i.S.d. <br />
                                Urhebergesetzes bei Veröffentlichung von Beiträgen und Themen im Forum und auf <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> <br />
                                zu beachten. <br />

                                Als Nutzer/Nutzerin räumst du lediglich uns mit Veröffentlichung deines Beitrages auf <br />
                                <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> das Recht ein, den Beitrag dauerhaft zum Abruf bereitzustellen. <br />

                                Ferner hat unser Team das Recht, deine Themen und Beiträge zu löschen, zu bearbeiten und <br />
                                innerhalb von <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> zu verschieben, um diese mit anderen Inhalten zu verknüpfen oder zu <br />
                                schließen.<br />
                                <br />

                                <h3> 4.) Haftungsbeschränkung </h3>

                                (1) Wir übernimmen keinerlei Gewähr für die auf <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> veröffentlichten und eingestellten <br />
                                Beiträge, Themen, externen Links und die daraus resultierenden Inhalte, insbesondere nicht <br />
                                für deren Richtigkeit, Vollständigkeit und Aktualität. Wir sind auch nicht verpflichtet, <br />
                                permanent die übermittelten und gespeicherten Beiträge der Nutzer/Nutzerinnen zu <br />
                                überwachen oder nach den Umständen zu erforschen, ob sie auf einen rechtswidrigen Inhalt <br />
                                hinweisen. Wir haften grundsätzlich nur im Falle einer vorsätzlichen oder grob fahrlässigen <br />
                                Pflichtverletzung.<br />
                                <br />

                                (2) Wir weisen ausdrücklich darauf hin, dass die juristischen Beiträge und Diskussionen im <br />
                                Forum vollkommen unverbindlich sind. <br />

                                Die Nutzung der Beiträge und deren Verwertung erfolgt auf deiner eigenen Gefahr.<br />
                                <br />

                                (3)   Bei Werbeschaltungen übernimmen wir keine Haftung für den Inhalt und die <br />
                                Richtigkeit. <br />

                                Für den Inhalt der Werbeanzeigen ist der jeweilige Autor einzig und allein verantwortlich; <br />
                                gleiches gilt für den Inhalt der beworbenen Webseite. <br />

                                Bei Darstellung der Werbeanzeige auf unserer Webseite , sind wir nicht gleichzeitig mit dem <br />
                                rechtswidrigen Inhalt einverstanden. <br />

                                Daher liegt die Haftung ausschließlich bei dem Werbekunden.<br />

                                (4)   Es wird nicht für einen ständigen unterbrechungsfreien Abruf von <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> garantiert. <br />
                                Einer Haftung diesbezüglich wird hiermit ausdrücklich widersprochen. Auch bei großer <br />
                                Sorgfalt können Ausfallzeiten leider nicht ausgeschlossen werden.<br />
                                <br />

                                <h3> 5.) Urheberrecht </h3>

                                Sämtliche Texte, Bilder und andere auf unserer Webseite veröffentlichten Informationen <br />
                                und Daten unterliegen - sofern nicht anders gekennzeichnet - dem Copyright von <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span>. <br />
                                Jede Form von Wiedergabe und/oder Modifikation darf nur mit der schriftlichen <br />
                                Genehmigung durch uns erfolgen. Andersfalls behalten wir uns das Recht vor gerichtlich <br />
                                gegen diese Rechtsverletzung vorzugehen. Alle Kosten, die durch eine Rechtsverletzung <br />
                                seitens eines Benutzers verursacht werden, werden diesem in Rechnung gestellt.<br />
                                <br />

                                <h3> 6.) Änderungsvorbehalt </h3>

                                Wir haben jederzeit das Recht die Nutzungsbedingungen zu ändern. Die Änderung wird dann <br />
                                per Eintrag auf <span className="black"><b>NGC</b></span><span className="red"><b>TV</b></span> veröffentlicht.<br />
                                <br />

                                <h3> 7.) Kündigung und Laufzeit der Mitgliedschaft </h3>

                                Die Laufzeit der Mitgliedschaft beginnt mit der Registrierung und mit dem Einverständnis <br />
                                unseren Nutzungsbedingungen und besteht auf eine unbestimmte Zeit. Die Mitgliedschaft <br />
                                kann jederzeit ohne Angabe von Gründen fristlos gekündigt werden.<br />
                                <br />

                                <h3> 8.) Salvatorische Klausel </h3>

                                Sollten einzelne Bestimmungen dieser AGB einschließlich dieser Regelungen ganz oder <br />
                                teilweise unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen oder Teile <br />
                                solcher Bestimmungen unberührt. Anstelle der unwirksamen oder fehlenden Bestimmungen <br />
                                treten die jeweiligen gesetzlichen Regelungen in Kraft.<br />
                                <br />
                                <br />


                                Niederkrüchten, den 30. Mai 2025<br />
                            </div>
                        </div>
                        <div className='row'>
                            <ShortTests />
                            <ShortNews />
                            <AdSlot slot="2119524913" />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default TermsOfUse;
